export default "__VITE_ASSET__C5lxMogJ__"